export const companiesQueryKeys = {
  samlClaimAlias: ({
    aliasId,
    companyId
  }: {
    aliasId?: string
    companyId: string
  }) =>
    [
      `companies/${companyId}/saml/claim-aliases/${aliasId}`,
      {
        aliasId,
        companyId
      }
    ] as const,
  samlClaimAliases: (companyId: string) =>
    [`companies/${companyId}/saml/claim-aliases`, companyId] as const,
  withoutTeams: (companyId: string) =>
    [`companies/${companyId}`, { skipTeams: true }] as const
}

export const companiesMutationKeys = {
  authenticationPreferences: (identifier: string) =>
    [`companies/${identifier}/auth/prefs`, { method: 'post' }] as const,
  deleteSamlClaimAlias: ({
    aliasId,
    identifier
  }: {
    aliasId: string
    identifier: string
  }) =>
    [
      `companies/${identifier}/saml/claim-aliases/${aliasId}`,
      { method: 'delete' }
    ] as const,
  identifier: (identifier: string) =>
    [`companies/${identifier}`, { method: 'patch' }] as const,
  postSamlClaimAlias: (identifier: string) =>
    [`companies/${identifier}/saml/claim-aliases`, { method: 'post' }] as const,
  samlProperties: (identifier: string) =>
    [`companies/${identifier}/saml/props`, { method: 'post' }] as const,
  updateSamlClaimAlias: ({
    aliasId,
    companyId
  }: {
    aliasId: string
    companyId: string
  }) =>
    [
      `companies/${companyId}/saml/claim-aliases/${aliasId}`,
      { method: 'put' }
    ] as const
}
